var map = {
	"./arrow-simulator.svg": "1119",
	"./clickandboat.svg": "99de",
	"./jetski.svg": "d675",
	"./jsmb-logo-white.svg": "ae6e",
	"./jsmb-logo.svg": "c25c",
	"./logo.svg": "9b19",
	"./niou/jetski.svg": "f392",
	"./niou/petit_bateau.svg": "6a07",
	"./niou/rigide.svg": "acf2",
	"./niou/semi_rigide.svg": "0af5",
	"./niou/voilier.svg": "a529",
	"./petit_bateau.svg": "d1b0",
	"./press/text.svg": "0734",
	"./remorque.svg": "ca10",
	"./rigide.svg": "2bff",
	"./semi_rigide.svg": "4315",
	"./trailer.svg": "97b3",
	"./voilier.svg": "688d",
	"./wave.svg": "46db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";